export const NoConditions = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        // eslint-disable-next-line max-len
        d="M13.18 15.083.915 2.817l.95-.95 12.267 12.266-.95.95Zm-2.633-6.416L9.214 7.333h2.783v1.334h-1.45ZM7.214 5.333 5.881 4h8.116v1.333H7.214ZM6.664 12v-1.333h2.667V12H6.664ZM3.997 8.667V7.333h2.767v1.334H3.997Zm-2-3.334V4h1.434v1.333H1.997Z"
      />
    </svg>
  );
};
